import { ORDER_STATUS } from './orderStatus';

export const REFUND_STATUS_LABELS = {
  PENDING: 'Estorno pendente',
  SUCCESS: 'Estorno realizado',
  FAILED: 'Estorno falhou',
  SKIPPED: 'Estorno não executado'
};

const REFUND_STATUS_COLORS = {
  PENDING: '#F18750',
  SUCCESS: '#228B22',
  FAILED: '#E83B3C',
  SKIPPED: '#999999'
};

export function getRefundStatusLabel(status) {
  return REFUND_STATUS_LABELS[status] || 'Sem estorno registrado';
}

export function getRefundStatusColor(status) {
  return REFUND_STATUS_COLORS[status] || '#F18750';
}

export function isOrderRefundBlockedByPayment(order) {
  return order?.isRefundable === false;
}

export function canAttemptOrderRefund(order) {
  if (
    !order ||
    order.refundStatus === 'SUCCESS' ||
    isOrderRefundBlockedByPayment(order)
  ) {
    return false;
  }

  if (order.canRetryRefund === true) {
    return true;
  }

  const hasNoAttempts = (order.refundAttempts ?? 0) === 0;
  const isCancelled = Number(order.status) === ORDER_STATUS.CANCELLED;

  return hasNoAttempts && isCancelled;
}

export function shouldShowOrderRefundSection(order) {
  return Boolean(
    order?.refundStatus ||
      order?.canRetryRefund === true ||
      isOrderRefundBlockedByPayment(order) ||
      canAttemptOrderRefund(order)
  );
}
